

import React from "react";
import SubscriptionRow, { SubscriptionColumns } from "../../../components/SubscriptionRow";

const SubscriptionManager = ({ dataSubscriptions, handleOpenEditSub, handleDeleteSubscription }) => {
    return (
        <>
            <span className="text-2xl font-semibold">Subscriptions</span>
            <div className="w-full max-h-[500px] bg-white rounded-lg shadow overflow-x-auto">
                <table className="min-w-[900px] w-full border-collapse border my-4 text-xs sm:text-sm">
                    <thead>
                        <tr className="bg-gray-200 text-center sticky top-0 z-10">
                            <th className="border p-2 border-black">#</th>
                            <th className="border p-2 border-black">Service</th>
                            <th className="border p-2 border-black">ID</th>
                            <th className="border p-2 border-black">User</th>
                            <th className="border p-2 border-black">Note</th>
                            <th className="border p-2 border-black">Plan</th>
                            <th className="border p-2 border-black">Quota Usages</th>
                            <th className="border p-2 border-black">Started/Expired</th>
                            <th className="border p-2 border-black">Type/Status</th>
                            <th className="border p-2 border-black">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataSubscriptions.map((sub, index) => {
                            return <SubscriptionRow
                                index={index}
                                sub={sub}
                                columns={[
                                    SubscriptionColumns.INDEX,
                                    SubscriptionColumns.SERVICE,
                                    SubscriptionColumns.ID,
                                    SubscriptionColumns.USER,
                                    SubscriptionColumns.NOTE,
                                    SubscriptionColumns.PLAN,
                                    SubscriptionColumns.QUOTA,
                                    SubscriptionColumns.TIME,
                                    SubscriptionColumns.TYPE_STATUS,
                                    SubscriptionColumns.ACTIONS,
                                ]}
                                onActionEdit={handleOpenEditSub}
                                onActionDelete={handleDeleteSubscription}
                            />
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default SubscriptionManager;